import { ButtonGroup, LinkButton } from "@digipost/dds-buttons-react";
import { Heading } from "@digipost/dds-heading-react";
import * as Sentry from "@sentry/react";
import { FC, useEffect, useState } from "react";
import { Link, useRouteError } from "react-router";

import { EntrypointLoadError } from "../../../types/errors";
import Header from "../header/Header";
import Translated from "../infrastructure/components/Translated";
import { useRootPath } from "../infrastructure/hooks/useRootPath";
import { useTranslate } from "../infrastructure/hooks/useTranslate";
import { logError } from "../infrastructure/serverlog";
import MobilMenu from "../mobilemenu/MobileMenu";
import StatusPageBanner from "../statuspage/StatusPageBanner";
import styles from "./ErrorPage.module.less";

const ErrorPage: FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const error = useRouteError();

  useEffect(() => {
    const sentryEventId = Sentry.captureException(error);
    logError(error, { origin: ErrorPage.name, sentryEventId });
  }, [error]);

  let errorInfo = (
    <>
      <Heading level={1} size={"large"}>
        <Translated textKey={"generic.error_header"} />
      </Heading>
      <Translated textKey={"generic.error_body"} />
    </>
  );

  const showNavButtons = !(error instanceof EntrypointLoadError);
  if (error instanceof EntrypointLoadError) {
    const loadError = error as EntrypointLoadError;
    if (loadError.apiError === "NOT_AUTHORIZED_SUSPENDED") {
      errorInfo = (
        <>
          <Heading level={1} size={"large"}>
            <Translated textKey={"login.failed_heading"} />
          </Heading>
          <Translated textKey={"login.account_suspended"} />
        </>
      );
    }
  }

  const translate = useTranslate();
  const rootPath = useRootPath();

  return (
    <div className={"App"}>
      <StatusPageBanner />
      <div className={styles.headerContainer}>
        <Header
          isActive={menuOpen}
          onShow={() => setMenuOpen((prevState) => !prevState)}
        />
      </div>
      {menuOpen && <MobilMenu />}
      <article className={styles.errorContent}>
        <img
          className={styles.oauthIllustration}
          src="/innlogging/images/illustrations/hund-snuser-pakke.svg"
          alt={translate("errorpage.illustration_alt")}
        />
        <div className={styles.errorContentText}>
          {errorInfo}
          {showNavButtons && (
            <ButtonGroup className={styles.errorContentLinks}>
              <LinkButton as={Link} to={`${rootPath}/`}>
                <Translated textKey={"errorpage.back_to_login"} />
              </LinkButton>
              <LinkButton as={Link} to={`${rootPath}/business`}>
                <Translated textKey={"errorpage.back_to_login_company"} />
              </LinkButton>
            </ButtonGroup>
          )}
        </div>
      </article>
    </div>
  );
};

export default ErrorPage;
